import styled from 'vue-styled-components';
import theme from '@/config/theme';

const WrapperProps = { color: String };

const Wrapper = styled('label', WrapperProps)`
  cursor: pointer;
  display: inline-block;
  position: relative;
  user-select: none;

  .label {
    align-items: center;
    color: ${theme.colors.gray6};
    display: flex;
    font-size: ${theme.font.sizes.p2};
    height: auto;
    min-height: 24px;
    padding-left: 36px;
    transition: .25s;
  }

  > input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;

    &:checked ~ .label {
      color: ${(props) => props.color ?? theme.colors.primary}
    }

    &:checked ~ .checkmark {
      background-color: ${(props) => props.color ?? theme.colors.primary};
      border-color: ${(props) => props.color ?? theme.colors.primary};

      &:after {
        display: block;
      }
    }

    &:disabled ~ .label {
      color: ${theme.colors.gray1}
    }

    &:disabled ~ .checkmark {
      background-color: ${theme.colors.gray1};
      border-color: ${theme.colors.gray1};
    }
  }

  > .checkmark {
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray6};
    border-radius: 6px;
    left: 0;
    height: 24px;
    position: absolute;
    top: 0;
    width: 24px;
    transition: .25s;

    &:after {
      border: solid white;
      border-width: 0 2px 2px 0;
      content: "";
      display: none;
      height: 7px;
      left: 8px;
      position: absolute;
      top: 5px;
      transform: rotate(45deg);
      width: 4px;
    }
  }

  &:hover > input:not(:checked):not(:disabled) {

    ~ .label {
      color: ${(props) => props.color ?? theme.colors.primary};
    }

    ~ .checkmark {
      border-color: ${(props) => props.color ?? theme.colors.primary};
      box-shadow: ${theme.shadow.btDefault};
    }
  }
`;

export default Wrapper;
